import { render, staticRenderFns } from "./itemPickerV2.vue?vue&type=template&id=54c59b0f"
import script from "./itemPickerV2.vue?vue&type=script&lang=ts"
export * from "./itemPickerV2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports